<template>
    <div class="home-wrapper">
        <div class="banner"><img :src="activityData.templateConfig.image" /></div>
        <div class="record" @click="goPage(() => goRecord())">我的奖品</div>
        <div class="video" v-if="activityData.templateConfig.video">
            <video ref="video" :src="activityData.templateConfig.video" :poster="activityData.templateConfig.poster"
                x5-playsinline playsinline webkit-playsinline controls loop autoplay />
        </div>
        <div class="lottery">
            <div class="lottery-num" v-if="userInfo.user_id || userInfo.token">
                今日还可抽 <span>{{ surplusDayCount }}</span> 次
            </div>
            <div class="lottery-item" v-for="(item, index) in list" :key="index" @click="goPage(() => chooseClick(index))">
                <img v-if="item === 1" src="../img/gift-open.png" />
                <img v-else src="../img/gift.png" />
            </div>
        </div>
        <div class="rule">
            <div class="rule-title"><img src="../img/rule-title.jpg" /></div>
            <div class="rule-inner" v-html="activityData.templateConfig.desc"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'
import wx from 'wechat-js-sdk'

let limitLuckCount = 0;  // 通过URL传参限制抽奖次数
let clickLuckCount = 0;  // 点击抽奖次数
export default {
    computed: {
        ...mapState(['activityData', 'aid', 'userInfo', 'shareData'])
    },
    data() {
        return {
            hasSet: false,
            isApp: false,
            isWeixin: false,
            list: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            chooseIndex: 0,
            luckInfo: {},
            countInfo: {},
            surplusDayCount: 0,  // 当日剩余次数
        }
    },
    watch: {
        userInfo(v) {
            if (v) this.getCount()
        }
    },
    mounted() {
        limitLuckCount = this.$route.query.limitLuckCount || 0;
        if (COVERAPP.Attribute.isWeixin()) {
            wx.hideMenuItems({
                menuList: ['menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email'],
            });
        }
        this.isApp = COVERAPP.Attribute.isApp()
        this.isWeixin = COVERAPP.Attribute.isWeixin()
        setTimeout(() => {
            this.SET_PAGELOADING(false);
            // COVERAPP.Method.onshare(this.shareData)
        }, 500)

        if (this.userInfo.user_id || this.userInfo.token) this.getCount()

        document.addEventListener('visibilitychange', this.listener)
        document.addEventListener('touchstart', this.autoplay)
    },
    unmounted() {
        this.hasSet = false
        document.removeEventListener('visibilitychange', this.listener)
        document.removeEventListener('touchstart', this.autoplay)
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA", "SET_USERINFO", "SET_PAGELOADING", "SET_TOASTDATA"]),
        autoplay() {
            if (this.$refs.video && !this.hasSet) {
                this.$refs.video.play()
                this.hasSet = true
            }
        },
        listener() {
            console.log(document.visibilityState)
            // 用户离开了当前页面
            if (document.visibilityState === 'hidden') {
                this.$refs.video && this.$refs.video.pause()
            }
            // // 用户打开或回到页面
            // if (document.visibilityState === 'visible') {
            //     this.$refs.video && this.$refs.video.play()
            // }
        },

        goRecord() {
            this.$router.push('/record')
        },
        getCount() {
            return COVER.$post('/lottery/query/count', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then(({ errno, data }) => {
                this.countInfo = data || {};
                this.handleSurplusDayCount();
            })
        },
        chooseClick(i) {
            if (this.list[i]) return false
            if (limitLuckCount && !this.surplusDayCount) {
                return this.SET_DIALOGDATA({
                    message: `已抽奖`,
                    btns: [
                        {
                            text: '确定',
                        }
                    ]
                })
            }
            if ((this.countInfo.luckDayTotal || 0) >= this.activityData.templateConfig.luckDayTotal) {
                return this.SET_DIALOGDATA({
                    message: `今日抽奖次数已用完`,
                    btns: [
                        {
                            text: '确定',
                        }
                    ]
                })
            }
            if ((this.countInfo.luckTotal || 0) >= this.activityData.templateConfig.luckTotal) {
                return this.SET_DIALOGDATA({
                    message: `抽奖次数已用完`,
                    btns: [
                        {
                            text: '确定',
                        }
                    ]
                })
            }
            this.luckReq(i)

        },
        luckReq(i) {
            this.SET_TOASTDATA('加载中')
            COVER.$post('/lottery/luck', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data) => {
                console.log(data)
                clickLuckCount++;
                if (data.errno === 0) {
                    this.SET_TOASTDATA(null)
                    // 中奖信息
                    if (data.amount) data.amount = (data.amount / 100).toFixed(2)
                    this.luckInfo = data.data

                    // 抽奖状态页面显示
                    this.chooseIndex = i
                    this.list[i] = 1
                    this.showLuckModal()
                    this.getCount()
                }
                else {
                    let err = data;
                    if (err.errno && err.errno != 1001) this.list[i] = 1
                    if (err && err.errmsg) {
                        this.SET_DIALOGDATA({
                            message: err && err.errmsg || '出错了',
                            btns: [
                                {
                                    text: '确定',
                                }
                            ]
                        })
                    }
                    this.getCount()
                }
            })
        },
        showLuckModal() {
            const btns = [
                {
                    text: '提交',
                    className: 'info-btn',
                    callback: (info) => {
                        this.submitInfo(info)
                    }
                }, {
                    text: '确定',
                }, {
                    text: '提现',
                    callback: () => this.getCash()
                }
            ]
            this.SET_DIALOGDATA({
                message: `恭喜您获得${this.luckInfo.name || '奖品'}`,
                field: this.activityData.templateConfig.field,
                btns: [
                    this.activityData.templateConfig.field && this.activityData.templateConfig.field.length
                        ? btns[0]
                        : btns[1]
                    //: !this.luckInfo.amount ? btns[1] : btns[2]
                ]
            })
        },
        submitInfo(info) {
            // this.$toast.loading('提交中')
            COVER.$post('/lottery/prize/info', {
                pid: this.luckInfo.pid,
                info: info,
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data) => {
                // this.$toast.clear()
                if (data.errno === 0) {

                    this.SET_DIALOGDATA({
                        message: '您的兑奖联系方式已提交成功。',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    // this.$toast.clear()
                    this.SET_DIALOGDATA({
                        message: '未中奖！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                }
            });
        },
        getCash() {
            COVER.$put('/lottery/cash', {
                aid: this.aid,
                pid: this.luckInfo.pid,
            }, 'put').then((data) => {
                if (data.errno === 0) {
                    this.$toast(`${this.luckInfo.amount}元提现成功`)
                } else {
                    if (data && data.errno == 1001 && data.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                        this.SET_DIALOGDATA({
                            message: '您的微信未实名认证，不能领取红包，请实名认证后领取',
                            btns: [
                                {
                                    text: '确定'
                                }
                            ]
                        })
                    } else if (!data || !data.errno || (data.errno && data.errno != 1250 && data.errno != 1010)) {
                        this.$toast('加载失败，请重试！')
                    }
                }
            })
        },
        goPage(callback) {
            if (!this.isApp && this.activityData.isAppShow) { //
                this.SET_DIALOGDATA({
                    message: '参加该活动需在APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'download-btn'
                        }
                    ]
                })
                return false
            }
            if ((!this.userInfo || !this.userInfo.token)) {
                this.SET_DIALOGDATA({
                    message: '亲，请登录参与活动',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'login-btn',
                            callback
                        }
                    ]
                })
                return false
            }
            // if (!this.userInfo.mobile) {
            //     this.SET_DIALOGDATA({
            //         message: '亲，请绑定手机号参与活动',
            //         btns: [
            //             {
            //                 text: '取消',
            //                 className: 'cancel-btn'
            //             },
            //             {
            //                 text: '确定',
            //                 className: 'bindmobile-btn',
            //                 callback
            //             }
            //         ]
            //     })
            //     return false
            // }
            callback && callback()
            return true
        },
        // 剩余次数计算
        handleSurplusDayCount() {
            const activityData = this.activityData;
            const countInfo = this.countInfo;
            const count = (activityData.templateConfig.luckDayTotal || 0) - (countInfo.luckDayTotal || 0);
            this.surplusDayCount = count;
            
            if (count && limitLuckCount) {
                this.surplusDayCount = limitLuckCount;
                if (clickLuckCount >= limitLuckCount) {
                    this.surplusDayCount = 0;
                }
            }
        }
    }
}
</script>

<style>
.home-wrapper {
    width: 100vw;
    min-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.home-wrapper .banner {
    width: 100%;
}

.home-wrapper .banner img {
    display: block;
    width: 100%;
    min-height: 56.25vw;
}

.home-wrapper .video {
    width: 100%;
}

.home-wrapper .video video {
    display: block;
    width: 100vw;
    min-height: 56.25vw;
}

.home-wrapper .record {
    position: absolute;
    top: 4vw;
    right: 3vw;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    padding: 1vw 3vw;
    border-radius: 5vw;
    font-size: 3vw;
}

.home-wrapper .record:active {
    background: rgba(0, 0, 0, 0.8);
}

.home-wrapper .lottery-num {
    color: #fff;
    position: absolute;
    width: 100%;
    text-align: center;
    top: 3vw;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1vw;
    font-size: 5vw;
}

.home-wrapper .lottery-num span {
    text-align: center;
    display: inline-block;
    border-radius: 1vw;
    color: #fff;
    font-weight: bold;
    letter-spacing: 0;
    margin-right: 1vw;
}

.home-wrapper .lottery {
    width: 100vw;
    background: url(../img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    padding: 10vw 7vw 18vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
}

.home-wrapper .lottery-item {
    width: 24.074vw;
    height: 35vw;
    animation: swing 1s 0.5s linear both;
}

.home-wrapper .lottery-item img {
    width: 100%;
    transform: scale(2);
    transform-origin: top;
}

.home-wrapper .rule {
    width: 100%;
}

.home-wrapper .rule .rule-inner {
    padding: 0 8vw 8vw;
    font-size: 3.5vw;
    line-height: 1.8;
    color: #999
}

@keyframes swing {

    20%,
    40%,
    60%,
    80%,
    100% {
        transform-origin: center
    }

    20% {
        transform: rotate(15deg)
    }

    40% {
        transform: rotate(-10deg)
    }

    60% {
        transform: rotate(5deg)
    }

    80% {
        transform: rotate(-5deg)
    }

    100% {
        transform: rotate(0deg)
    }
}
</style>
